import { jsxs, jsx } from "react/jsx-runtime";
import { useFunction } from "@project-rouge/rg-three";
import { useState } from "react";
import { useMemoState } from "./index38.js";
const fontFamily = '"Open Sans", "Segoe UI", Tahoma, sans-serif';
const max = 25;
const WingInput = ({ value, onChange, min }) => {
  const [currValue, setCurrValue] = useMemoState(`${value}`);
  const [focus, setFocus] = useState(true);
  const _onChange = useFunction((e) => {
    if (!e.target.value) {
      setCurrValue("");
      return;
    }
    let newValue = parseInt(e.target.value);
    if (isNaN(newValue))
      newValue = value;
    if (newValue < min)
      newValue = min;
    if (newValue > max)
      newValue = max;
    if (newValue === value)
      return;
    onChange(newValue);
  });
  const onFocus = useFunction(() => {
    setFocus(true);
  });
  const onBlur = useFunction(() => {
    setFocus(false);
  });
  const stopClickEvent = useFunction((e) => {
    e.stopPropagation();
  });
  const onKeyDown = useFunction((e) => {
    if (e.key !== "ArrowUp" && e.key !== "ArrowDown")
      return;
    e.preventDefault();
  });
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: "rg-styles",
      onClick: stopClickEvent,
      onDoubleClick: stopClickEvent,
      style: {
        border: "1px solid",
        borderColor: !focus ? "#AFB7BF" : "#12736E",
        borderRadius: 4,
        fontSize: 14,
        fontFamily,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#60666C",
        background: "#fff",
        padding: "0 8px",
        width: "95px",
        lineHeight: "20px"
      },
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            autoFocus: true,
            type: "number",
            value: currValue,
            onChange: _onChange,
            onKeyDown,
            maxLength: 2,
            min,
            max,
            className: "rg-no-arrows",
            onFocus,
            onBlur,
            style: {
              display: "block",
              outline: "none",
              fontFamily: "inherit",
              fontSize: "inherit",
              fontWeight: !focus ? "normal" : 600,
              color: !focus ? "#60666C" : "#0D0E0F",
              textAlign: "right",
              border: "none",
              width: "2.5em",
              lineHeight: "normal",
              padding: 0,
              boxShadow: "none",
              marginRight: "0.3em"
            }
          }
        ),
        /* @__PURE__ */ jsx("div", { children: "floors" })
      ]
    }
  );
};
export {
  WingInput
};
//# sourceMappingURL=index173.js.map
